import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

import { BlankButton } from '../BlankButton';
import Link from '../Link';

export const SidebarLink = styled(Link)`
  &&& {
    font-family: ${tokens.font.family.ifood.body};
    font-weight: bold !important;
    font-size: ${tokens.fontSizes.s};
    line-height: ${tokens.lineHeights.m};
    color: ${tokens.colors.black};
    display: block;
    padding-left: ${tokens.space.regular};
    border-left: ${tokens.radii.s} solid ${tokens.colors.white};

    &:focus {
      color: ${tokens.colors.black};
    }

    &.active {
      border-left: ${tokens.radii.s} solid ${tokens.colors.primary};
      color: ${tokens.colors.primary};
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  &:not(:empty) {
    padding: 0 0 ${tokens.space.regular} ${tokens.space.larger};
  }
`;

export const DrillDown = styled(BlankButton)`
  flex: 1;
  display: flex;
  justify-content: flex-end;
`;
